import * as types from './actionTypes';
import consultantApi from '../api/consultantApi';

export function getDigitalStoreDetails(usuario, params) {
  return function (dispatch) {
    return dispatch({type: types.GET_DIGITAL_STORE_DETAILS, payload: consultantApi.getDigitalStoreDetails(usuario, params)});
  };
}